module.exports = __webpack_public_path__ + "static/media/rightTriangle.e60acb6a.svg";